"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OptionsReader =
/** @class */
function () {
  function OptionsReader(globalContext) {
    this.globalContext = globalContext;
  }

  Object.defineProperty(OptionsReader.prototype, "window", {
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(OptionsReader.prototype, "document", {
    get: function get() {
      if (this.window) {
        return this.window.document;
      }

      return undefined;
    },
    enumerable: true,
    configurable: true
  });
  return OptionsReader;
}();

exports.OptionsReader = OptionsReader;